const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLounge1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 200 3484.545 2000",
    style: {
      enableBackground: "new 0 200 3484.545 2000"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "xMinYMin slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "#FFFFFF"
    },
    width: 3484.545,
    height: 2000
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EDFF6"
    },
    d: "M341.757,1842.043c0,0-187.409-647.338,167.63-1028.999 c227.371-244.42,598.347-171.802,598.347-171.802s506.481-739.139,1001.779-424.279 c665.845,423.276,650.935,2.129,1001.544,247.637c418.355,292.946,0,1417.628,0,1417.628L341.757,1842.043z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.0458,
    y1: 1155.9955,
    x2: 3199.6389,
    y2: 1155.9955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCE3F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0F7FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M3073.472,717.533c-292.269-345.385-512.001,125.11-939.243-182.419 c-611.835-440.399-656.551,714.407-862.975,681.325c-294.207-47.151-329.076-296.392-669.706-87.776 c-85.135,52.14-198.99,185.732-230.558,342c-33.13,164,7.795,355.179,7.795,355.179l2707.591,51.315 C3160.432,1697.208,3305.604,991.852,3073.472,717.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE978E"
    },
    d: "M3142.079,1887.258H326.495c-30.17,0-54.627-24.458-54.627-54.627v-6.788h2924.839v6.788 C3196.706,1862.8,3172.249,1887.258,3142.079,1887.258z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE0B2"
    },
    d: "M1389.468,519.994h291.576c27.797,0,50.332-22.534,50.332-50.331V368.999 c0-27.797-22.535-50.331-50.332-50.331h-291.576c-27.797,0-50.331,22.534-50.331,50.331v100.664 C1339.137,497.46,1361.671,519.994,1389.468,519.994z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAE0B2"
    },
    points: "1621.316,496.648 1501.985,602.455 1528.056,493.314  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M2631.439,808.588l-6.471-29.438c0,0-21.179,13.439-33.534,32.637 c-12.355,19.199-18.239,70.394-21.768,72.315c-3.529,1.92-42.618-58.307-49.452-67.8c-8.453-11.74-11.613-25.218-16.908-35.457 c-5.294-10.239-23.935-13.725-30.996-12.445c-7.059,1.28,9.698,31.228,9.698,31.228s42.359,73.594,56.478,113.911 c14.12,40.316,58.244,59.515,65.303,53.755C2610.848,961.535,2631.439,808.588,2631.439,808.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2502.836,786.481c0,0-1.761-7.749-6.516-9.334c-4.755-1.585-13.032-0.176-13.561,0 c-0.527,0.176-9.686-4.755-9.686-4.755l7.574,14.089c0,0,14.792,17.435,19.724,10.919 C2505.303,790.883,2502.836,786.481,2502.836,786.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M2470.433,773.037c0,0-5.343,27.18-3.992,32.874c1.354,5.712,4.762,2.65,5.401,1.409 c2.627-5.109,4.461-22.543,4.461-22.543L2470.433,773.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M2481.938,795.638c0,0-2.547,16.857-5.167,18.843c-1.702,1.292-3.875,0.529-4.579-2.876 c-0.704-3.405,3.406-24.186,3.406-24.186L2481.938,795.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M2497.507,843.47l8.865-4.321l-37.656-77.254l0,0c-4.895,2.387-6.931,8.291-4.545,13.187 L2497.507,843.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2592.132,687.536c-5.315-24.159-10.521-48.471,3.491-75.012 c11.339-21.479,30.938-33.837,53.625-36.529c64.277-7.626,50.539,52.379,140.376,65.369c27.915,4.036,53.848,7.916,77.155,21.799 c42.084,25.069,57.97,65.282,30.061,130.795c-68.341,160.418-236.092,24.234-256.812-7.354 C2624.615,763.106,2595.553,703.088,2592.132,687.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2849.189,1700.852c0,0,4.576,46.472,16.343,55.004c11.766,8.533,27.455,40.104,19.61,57.169 c-2.451,5.333-7.354,8.416-12.936,10.134c-16.531,5.09-34.117-3.481-41.154-19.281c-3.932-8.826-7.382-20.6-8.075-35.436 c-1.765-37.757-13.531-56.956-13.531-56.956L2849.189,1700.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2668.381,1719.872c0,0-3.709,46.891-0.699,62.131c1.613,8.16,10.591,24.957,6.471,32.637 c-4.118,7.679-8.824,9.599-8.824,9.599l-106.73,1.716c-5.813,0.094-1.972-3.64,2.717-7.08 c7.673-5.631,13.864-9.352,38.374-21.185c1.597-0.77,7.419-4.464,9.516-5.743c5.323-3.244,10.666-8.348,15.269-13.46 c7.663-8.515,8.333-49.809,8.333-49.809L2668.381,1719.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2584.962,1096.563c0,0-13.439,76.135-4.615,126.049c8.824,49.913,51.18,512.572,51.18,512.572 l47.069,2.65c0,0,9.865-193.263,8.102-220.139c-1.766-26.876-15.734-71.854-15.734-71.854l4.685-156.038l-59.397-204.99 L2584.962,1096.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2723.299,1080.551c0,0,37.063,55.673,45.887,101.746c8.824,46.074-6.477,187.67,10.498,248.046 c9.189,32.684,44.017,83.158,49.312,125.393c5.294,42.234,26.064,152.864,26.064,152.864l-47.046,9.307l-109.34-276.292 l-85.767-249.726l-21.971-128.616L2723.299,1080.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2693.297,763.794c0,0,32.456,3.683,51.869,24.8c19.414,21.117-31.379,190.865-34.909,217.742 c-3.53,26.876,28.927,89.573,28.927,89.573s-121.276,22.413-154.221,0.654c0,0-3.529-193.264,0-212.462 c3.531-19.199,32.946-97.273,40.006-104.952C2632.028,771.47,2693.297,763.794,2693.297,763.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2739.194,804.529c-3.129-9.458-13.853-14.014-22.997-10.061 c-12.531,5.418-29.831,15.7-38.281,33.318c-14.119,29.437-63.539,130.549-78.834,134.389 c-15.296,3.84-77.658-104.951-77.658-104.951s1.765-19.198-3.53-30.077c-5.294-10.88-21.179-22.399-23.532-18.559 c-2.354,3.839,8.824,13.438,8.824,15.359c0,1.92-4.706,3.2-11.178-0.64c-6.471-3.84-9.976-11.605-9.976-11.605 s-10.614,19.284,0.563,36.563c11.178,17.279,15.885,24.318,15.885,24.318s72.363,160.626,98.837,162.547 C2621.971,1036.917,2763.971,879.425,2739.194,804.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2676.961,698.354c0,0,0.254,1.443,0.711,3.897c2.187,11.774,10.612,50.832,16.304,61.57 c6.879,12.976-23.548,54.362-52.833,49.311c-8.718-1.503,7.369-38.026,6.595-41.895c-1.479-7.405-3.487-17.508-5.539-27.867 c-1.159-5.844-2.332-11.769-3.434-17.337c-3.132-15.826-5.688-28.769-5.688-28.769L2676.961,698.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2677.672,702.251c-0.457-2.454-0.711-3.897-0.711-3.897l-43.884-1.091 c0,0,2.556,12.943,5.688,28.769c1.095,5.538,2.262,11.428,3.413,17.24c6.775-0.996,13.854-4.283,20.953-10.484 c7.739-6.76,12.81-14.884,15.871-23.558C2678.462,706.463,2678.011,704.077,2677.672,702.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2650.564,594.056c0,0,17.897,2.483,30.862,19.218c12.965,16.735,26.94,68.488-5.268,96.625 c-32.207,28.137-64.031-3.712-68.75-37.481C2602.69,638.649,2603.644,592.837,2650.564,594.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2597.101,660.878c3.844,7.458,10.297,11.588,14.413,9.224c4.115-2.364,4.335-10.326,0.492-17.785 c-3.845-7.458-10.298-11.588-14.414-9.225C2593.476,645.456,2593.257,653.419,2597.101,660.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2645.112,593.274c0,0,27.633,49.215,47.401,51.489c19.769,2.275,22.364,28.425,22.364,28.425 s-7.067-60.258-26.638-71.878C2668.669,589.688,2645.112,593.274,2645.112,593.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2686.049,656.489c-1.607,8.74,1.627,16.755,7.223,17.902c5.597,1.146,11.436-5.008,13.043-13.748 c1.607-8.74-1.625-16.755-7.221-17.902C2693.497,641.594,2687.656,647.749,2686.049,656.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2827.845,1795.566c25.641,4.666,42.702-10.304,51.579-21.51 c6.517,12.694,10.512,28.54,5.718,38.968c-4.222,9.185-15.717,11.697-25.432,12.057c-10.271,0.38-19.877-4.991-24.974-13.917 C2832.356,1806.996,2829.902,1801.804,2827.845,1795.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2609.221,1791.937c28.227,7.228,49.093,2.314,60.764-2.382 c3.011,8.514,7.001,19.194,4.885,25.353c-2.592,7.541-6.281,9.246-9.54,9.331c-25.782,0.676-94.441,1.595-114.101,1.852 c-2.745,0.036-4.259-3.166-2.494-5.269C2553.609,1815.01,2607.117,1793.22,2609.221,1791.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE0B2"
    },
    d: "M2385.843,458.371h235.221c22.425,0,40.603-18.179,40.603-40.603V336.56 c0-22.425-18.179-40.603-40.604-40.603h-235.22c-22.425,0-40.604,18.179-40.604,40.603v81.207 C2345.24,440.192,2363.418,458.371,2385.843,458.371z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAE0B2"
    },
    points: "2560.859,435.969 2591.661,528.377 2502.053,435.969  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2568.785,383.348c0,8.17,7.097,14.793,15.851,14.793c8.752,0,15.849-6.623,15.849-14.793 c0-8.169-7.097-14.792-15.849-14.792C2575.882,368.556,2568.785,375.179,2568.785,383.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2487.775,383.348c0,8.17,7.095,14.793,15.849,14.793c8.754,0,15.85-6.623,15.85-14.793 c0-8.169-7.096-14.792-15.85-14.792C2494.87,368.556,2487.775,375.179,2487.775,383.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2406.763,383.348c0,8.17,7.095,14.793,15.85,14.793s15.85-6.623,15.85-14.793 c0-8.169-7.095-14.792-15.85-14.792S2406.763,375.179,2406.763,383.348z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1124.766,432.403H846.498c-26.529,0-48.034-21.506-48.034-48.034V288.3 c0-26.529,21.505-48.034,48.034-48.034h278.268c26.529,0,48.034,21.506,48.034,48.034v96.069 C1172.8,410.897,1151.295,432.403,1124.766,432.403z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A491"
    },
    points: "917.721,405.902 881.281,515.221 987.289,405.902  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M908.344,343.651c0,9.665-8.395,17.5-18.751,17.5c-10.354,0-18.749-7.835-18.749-17.5 c0-9.664,8.395-17.499,18.749-17.499C899.949,326.151,908.344,333.986,908.344,343.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1004.18,343.651c0,9.665-8.394,17.5-18.749,17.5c-10.356,0-18.75-7.835-18.75-17.5 c0-9.664,8.394-17.499,18.75-17.499C995.786,326.151,1004.18,333.986,1004.18,343.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1100.017,343.651c0,9.665-8.394,17.5-18.75,17.5s-18.75-7.835-18.75-17.5 c0-9.664,8.394-17.499,18.75-17.499S1100.017,333.986,1100.017,343.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48C7F"
    },
    d: "M1932.696,1129.85c19.852-5.72,20.384-2.18,22.903-2.982c2.977-0.949,26.991-33.474,26.991-33.474 s71.475-95.34,75.135-100.639l22.542-123.368l67.715-0.536c0,0-28.288,133.228-31.054,139.824s-116.035,123.045-125.633,133.643 c0,0-6.203,17.212-10.478,27.859c-4.275,10.648-13.427,18.432-15.126,21.204c-0.251,0.41-6.501,9.269-17.406,17.897 c-9.398,7.437-4.431-4.14-4.431-4.14s14.545-17.064,12.841-18.08c-1.313-0.783-8.641,9.046-18.94,17.387 c-2.647,2.145-5.269,4.252-7.697,6.167c-6.37,5.026-11.768,2.353-6.074-4.023c2.012-2.252,5.454-5.905,8.325-8.134 c3.1-2.408,5.045-5.672,7.292-8.115c4.46-4.85,7.781-8.324,7.456-8.415c-0.423-0.116-0.303-1.753-3.196,0.431 c-3.477,2.627-9.428,9.919-14.89,13.368c-3.098,1.954-9.275,6.448-9.275,6.448s-10.821,4.967-11.397,4.42 c-3.115-2.962,3.079-8.478,7.702-10.564c2.086-2.866,8.742-7.401,8.742-7.401s11.033-12.313,9.098-14.029 c-0.823-0.732-8.605,5.943-17.416,11.22c-8.18,4.899-17.406,8.468-18.815,6.944c-2.386-2.584,6.002-9.024,6.002-9.024 s6.156-4.181,8.076-5.732c2.25-1.819,8.505-7.807,8.505-7.807s20.673-21.93,18.713-23.415c-1.959-1.487-8.37-3.495-10.184-2.615 c-1.811,0.879-4.085,4.273-5.898,5.152c-1.812,0.88-5.112,0.442-6.621-1.749c-1.509-2.192,5.229-9.873,5.229-9.873 S1926.964,1131.501,1932.696,1129.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2045.125,1748.751c0,0,2.409,42.564,2.424,42.652c0.885,5.403,4.373,18.755,4.373,23.668 c0,18.456-82.115-15.666-63.712-23.846c1.666-0.74,10.392-6.339,10.939-12.62c0.845-9.678,2.985-29.258,2.985-29.258 L2045.125,1748.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M1988.413,1791.051c0,0,19.279,5.646,29.154,7.056c9.874,1.412,22.891-10.472,29.876-7.262 c7.687,3.533,6.91,38.325,6.91,38.325s-102.911,6.065-131.981-3.301C1910.853,1822.159,1949,1804.2,1988.413,1791.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2226.04,1752.835c0,0,2.409,42.565,2.423,42.653c0.885,5.404,4.374,18.756,4.374,23.668 c0,18.457-82.115-15.666-63.713-23.845c1.667-0.741,12.98-10.519,13.528-16.799c0.844-9.679,0.397-25.078,0.397-25.078 L2226.04,1752.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#184655"
    },
    d: "M2169.328,1795.135c0,0,19.278,5.646,29.153,7.057c9.875,1.412,22.892-10.473,29.876-7.264 c7.688,3.535,7.995,35.338,7.995,35.338s-110.02,7.975-135.887,0.488C2088.841,1827.39,2129.915,1808.285,2169.328,1795.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#355389"
    },
    d: "M2095.911,1138.395l-34.717,14.976l-73.028,348.747l2.96,261.445l58.541,1.361 c0,0,27.229-228.697,27.229-246.42c0-17.724,126.121-310.157,126.121-310.157L2095.911,1138.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M2122.706,1157.584c0,0,25.578,268.7,25.578,313.992c0,45.295,20.737,298.794,20.737,298.794 l58.681-0.34c0,0,4.234-77.269,10.525-190.943c0.985-17.803-1.269-53.725,0-72.156c9.128-132.562,27.183-257.353,18.56-306.818 c-1.387-7.961-3.997-28.782-9.075-34.036C2209.284,1126.321,2122.706,1157.584,2122.706,1157.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C8F7C"
    },
    d: "M2051.127,945.528l71.008-4.756c0,0,3.504-63.472,3.504-93.748 c0-36.732,11.196-90.889,6.819-89.87c-12.283,2.858-33.49,14.166-43.339,27.881 C2055.039,832.494,2051.127,945.528,2051.127,945.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2219.357,755.748c0,0,40.491,5.63,51.149,13.456c12.004,8.814,25.323,28.537,25.323,28.537 s-49.714,235-49.802,274.544c-0.069,30.594,10.764,105.713,10.764,105.713s-150.233,9.483-207.132-12.978 c0,0,17.967-89.341,17.967-112.799s21.492-236.782,26.383-251.68c4.438-13.517,12.549-37.807,40-43.796 C2161.461,750.757,2219.357,755.748,2219.357,755.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2208.301,692.478l10.023,65.622c0,0-36.603,78.136-58.454,71.359 c-18.334-5.685-7.054-74.821-7.054-74.821s9.993-37.128,6.996-55.707C2156.815,680.351,2208.301,692.478,2208.301,692.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F47458"
    },
    d: "M2159.812,698.931c-2.997-18.579,48.489-6.453,48.489-6.453l0.832,5.443 c-1.506,3.641-3.349,6.757-5.584,9.146c-11.5,12.295-29.477,19.679-45.018,20.237 C2160.085,717.286,2161.041,706.549,2159.812,698.931z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2216.749,599.64c1.454-0.525,11.664,74.74-7.71,95.449 c-19.374,20.709-57.12,27.487-70.659,11.177c-14.975-18.041-14.223-98.934,15.898-120.236 C2184.399,564.726,2216.749,599.64,2216.749,599.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2165.744,545.768c23.282,4.715,38.363,18.849,43.903,24.872 c10.571,1.24,24.94,7.044,39.778,31.447c18.243,30.006,4.77,63.249-16.467,79.56c-21.237,16.311-20.997,35.246-20.997,35.246 l-3.302-9.84c-2.478-7.383-3.489-15.211-2.66-22.954c0.497-4.646,1.499-9.67,3.435-13.8c5.108-10.893-10.972-18.13-15.48-27.193 c-3.472-6.978-3.641-22.942-9.111-34.477l-6.531-8.805c0,0-15.071-11.65-29.814-8.362 C2133.752,594.749,2135.874,539.717,2165.744,545.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2194.944,656.5c-0.153,9.183,4.048,16.7,9.386,16.791c5.337,0.09,9.789-7.281,9.943-16.464 c0.153-9.182-4.049-16.7-9.387-16.791C2199.548,639.947,2195.097,647.318,2194.944,656.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13375B"
    },
    d: "M2116.098,994.79l-0.971,5.603c-0.498,2.883-3.24,4.815-6.124,4.316l-116.122-20.112 c-2.881-0.499-4.815-3.241-4.315-6.124l0.971-5.604c0.499-2.883,3.241-4.815,6.123-4.316l116.122,20.111 C2114.666,989.165,2116.598,991.906,2116.098,994.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M2280.716,786.008c-13.624-0.395-25.675,89.47-17.038,98.335 c8.637,8.865,10.285,119.548,10.285,119.548l-128.526-3.195l-0.017,0.044c-2.506-1.681-29.432-19.764-33.282-23.717 c-4.04-4.146-23.661-2.073-28.854,3.627c-5.194,5.702,11.542,1.037,16.159,4.147c4.616,3.11-3.464,10.884-3.464,10.884 s-32.572,4.727-38.919-2.012c-6.349-6.738-23.312-18.143-25.62-11.405c-1.191,3.477,7.558,14.011,12.485,18.432 c-6.15-4.603-13.513-9.493-16.04-8.643c-4.617,1.555-2.693,7.429-0.192,9.156c2.5,1.727,28.358,21.469,32.397,22.852 c3.946,1.35,64.089,2.835,74.479,5.138c0,0,169.489,38.594,179.125,36.186c8.453-2.113,16.908-56.362,16.908-97.917 C2330.601,925.913,2323.29,787.241,2280.716,786.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50BFA5"
    },
    d: "M2263.044,765.507c0,0,23.709,5.46,48.2,32.982c22.274,25.028,36.306,165.188,36.306,165.188 l-76.907,12.434l-6.142-67.799l-20.549-31.013L2263.044,765.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20110C"
    },
    d: "M1275.336,630.758c0,0-62.914-16.161-70.418,50.794c-7.503,66.955,26.551,77.344,8.081,109.667 c-18.471,32.323-39.249,8.081-43.29,99.855c-4.04,91.774,206.437,203.251,261.867,148.774 c180.228-177.133-33.639-249.288-24.981-303.544c8.658-54.257-16.072-100.314-48.973-119.939 C1324.723,596.741,1282.84,596.704,1275.336,630.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M1489.016,1768.976c0,0-1.141,17.457,7.754,27.38c8.894,9.924,41.983,15.186,46.429,26.476 c4.446,11.293-33.34,11.988-46.041,8.533c-12.701-3.457-45.698-6.182-53.959-6.634s10.622-55.352,12.316-56.87 C1457.209,1766.341,1489.016,1768.976,1489.016,1768.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M1295.759,1758.163c0,0,8.195,36.859,7.417,51.088c-0.778,14.228-18.096,36.3-31.407,35.571 c-13.311-0.727-24.333-9.616-21.085-26.931c3.249-17.317,13.325-58.483,13.325-58.483L1295.759,1758.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#466EB6"
    },
    d: "M1197.063,1135.789c0,0-8.493-280.77,4.838-294.1c5.34-5.34,48.974-19.745,78.795-24.648 c44.625-7.337,79.582-4.195,79.582-4.195s45.474,54.497,45.474,74.722c0,20.225,2.904,250.388,2.904,250.388 c35.198,12.972,89.664,246.128,93.745,306.198c4.082,60.069-4.749,339.481-4.749,339.481l-51.255-5.564 c-27.985-43.882-40.588-274.975-48.765-303.738c-11.285-39.696-64.278-161.25-64.278-161.25l-27.298-11.904 c0,0,6.32,183.224,4.011,225.451c-2.308,42.226,0.321,246.768,0.321,246.768l-51.406-2.811 c-40.248-72.174-68.998-405.201-68.045-422.642c0.954-17.442-16.818-46.035-20.534-95.957 C1167.471,1212.592,1197.063,1135.789,1197.063,1135.789z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1287.027,
    y: 1128.572,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 2665.2346 2266.7979)",
    style: {
      fill: "#FFFFFF"
    },
    width: 91.181,
    height: 9.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#271798"
    },
    d: "M1324.374,1142.103h17.57c3.235,0,5.857-2.622,5.857-5.857v-4.21 c0-3.235-2.623-5.857-5.857-5.857h-17.57c-3.234,0-5.857,2.622-5.857,5.857v4.21 C1318.517,1139.48,1321.139,1142.103,1324.374,1142.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38,
      fill: "#001C41"
    },
    d: "M1197.063,1135.789c0,0-7.542-249.339,2.746-289.228 c13.348-8.992,55.804-24.898,66.203-25.718c-1.895,20.501,16.707,135.811,35.793,195.023 c12.05,37.385,10.267,83.239,5.719,118.874h0.02c-2.842,22.174-7.209,43.57-12.182,62.271 c-1.097,0.334-29.401,15.521-78.576,15.524c-2.103-0.115-20.522-1.344-41.57-4.623 C1182.99,1172.315,1197.063,1135.789,1197.063,1135.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38,
      fill: "#001C41"
    },
    d: "M1348.173,1199.801c-1.082-3.55,7.282-44.093,9.894-65.062h0.056 c17.288-140.413,1.722-319.234,1.484-321.948c0.009,0.001,0.022,0.001,0.031,0.002c1.048,1.028,4.013,4.374,7.967,9.166 c12.205,15.553,35.596,47.088,37.947,63.155c0.041,0.481,0.068,0.952,0.068,1.405c0,0.135,0,0.28,0,0.433 c0.005,2.534,0.043,7.582,0.109,14.553c0.01,1.356,0.068,2.776,0.162,4.247c0.581,59.211,2.764,232.202,2.764,232.202 c11.369,4.191,24.747,31.354,37.789,68.233C1404.09,1208.84,1351.165,1209.615,1348.173,1199.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09379"
    },
    d: "M1147.287,1172.432c-0.079,35.208,94.692,37.693,139.74,17.468l-4.903-152.61l-15.456-217.365 c0,0-56.938,11.294-76.321,24.473c0,0-6.286,225.988-11.802,271.955C1173.029,1162.319,1147.324,1156.382,1147.287,1172.432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09379"
    },
    d: "M1410.361,825.169c0,0,22.237,179.951,22.237,226.837c0,46.885,8.878,127.781,8.878,127.781 s-47.962,18.387-81.439,10.113c0,0,31.795-180.52,31.795-192.306c0-11.786-32.227-184.872-32.227-184.872 S1390.207,814.362,1410.361,825.169z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#271798"
    },
    points: "1440.106,1781.5 1502.3,1785.546 1502.375,1769.458 1437.622,1765.918  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#271798"
    },
    points: "1252.007,1771.136 1313.695,1775.18 1314.047,1759.163 1249.294,1755.622  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001653"
    },
    d: "M1446.7,1792.937c4.906,6.199,20.909,18.893,67.749,13.281c12.195,4.92,25.99,9.605,28.75,16.613 c4.446,11.293-33.34,11.988-46.041,8.532c-12.701-3.456-45.698-6.181-53.959-6.633 C1438.696,1824.484,1442.254,1808.071,1446.7,1792.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001653"
    },
    d: "M1303.176,1809.251c-0.778,14.228-18.096,36.3-31.407,35.571 c-13.311-0.727-24.333-9.616-21.085-26.932c1.093-5.827,2.96-14.358,4.956-23.112c1.697,10.803,6.716,29.188,20.922,22.826 c15.375-6.884,22.17-22.863,24.864-29.094C1302.619,1796.495,1303.448,1804.263,1303.176,1809.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18,
      fill: "#001653"
    },
    d: "M1436.003,1120.853c-17.995-0.914-40.875-2.069-63.41-3.181 c1.341-7.802,2.715-15.829,4.083-23.861l57.621,3.058C1434.797,1104.838,1435.385,1112.988,1436.003,1120.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18,
      fill: "#001653"
    },
    d: "M1284.58,1113.722c-0.108-0.001-0.216-0.002-0.31-0.002 c-13.98,0-68.393,14.851-88.157,14.851c-7.563,0-13.835-2.174-18.698-4.86c0.031-0.164,0.061-0.34,0.091-0.507 c0.397-2.149,0.748-4.424,1.039-6.852c0.141-1.177,0.283-2.477,0.425-3.883c0.713-6.808,1.24-14.507,1.717-21.767h103.153 L1284.58,1113.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09379"
    },
    d: "M1409.968,825.562c0,0,16.825,3.539,40.573,83.107c23.748,79.569,7.968,181.792-8.419,192.404 c-16.388,10.612-175.54,6.683-175.54,6.683l-0.616-57.327c0,0,120.486-18.827,132.413-33.456 c2.93-3.594-2.1-18.992-1.052-36.506C1400.546,926.692,1409.968,825.562,1409.968,825.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC7A63"
    },
    d: "M1404.075,1008.523c0,0,16.467-11.339,22.652-18.924c6.184-7.586,18.562-17.789,19.112-12.379 c0.551,5.41-5.116,13.202-5.116,13.202s22.499-15.717,25.48-13.287c2.98,2.429,5.936,19.271,3.853,37.867 c-2.083,18.596-54.826,32.132-54.826,32.132L1404.075,1008.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6A088"
    },
    d: "M1193.701,1116.661c57.385,9.575,178.493-33.069,227.604-48.501l-18.409-63.714 c0,0-144.641,40.016-163.593,31.511c-9.368-4.204-33.376-48.751-42.181-94.059c-9.008-46.349-6.775-97.5-6.775-97.5 s-41.551,54.356-29.842,169.434C1169.441,1101.642,1168.45,1112.448,1193.701,1116.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC7A63"
    },
    d: "M1208.221,985.903c0,0,13.547,11.464,24.112,20.077c10.566,8.614,27.124,31.76,27.124,31.76 s-19.649,4.666-26.534,5.366c-6.885,0.701-29.533-11.9-37.402-11.1c-7.868,0.8-5.577-10.861,4.068-8.861 c9.644,2,19.188,3.017,19.188,3.017s-22.627-14.84-33.193-23.454c-10.566-8.614-2.014-15.13,6.631-8.083 c8.644,7.048,18.017,11.04,18.017,11.04s-30.443-25.721-26.025-31.139C1188.624,969.108,1208.221,985.903,1208.221,985.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F26E5A"
    },
    d: "M1332.852,749.939c0,0,3.244,45.475,7.468,55.4c1.207,2.836,3.257,4.937,5.569,6.491 c11.965,8.041-9.392,109.281-20.276,107.045c-11.738-2.412-40.775-65.201-50.135-85.573c-2.77-6.028-0.273-13.304,5.767-16.047 c0.025-0.012,0.049-0.022,0.073-0.033c10.097-4.48,2.653-87.838,2.653-87.838L1332.852,749.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#F26E5A"
    },
    d: "M1290.671,726.099c0,0-2.41,1.349-2.138,4.853c0.543,6.999,4.194,15.72,7.333,22 c14.512,29.02,35.462,43.045,49.893,45.031c-3.591-14.675-6.205-51.329-6.205-51.329L1290.671,726.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7E72"
    },
    d: "M1282.378,693.631c0,0,7.433-32.842,32.063-42.584c24.629-9.742,47.153-2.418,55.702,29.726 c8.549,32.144-3.819,83.137-18.785,98.789C1336.391,795.214,1284.234,768.98,1282.378,693.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7E72"
    },
    d: "M1289.758,704.018c0,0-12.342-19.125-19.922-8.063c-7.581,11.062-0.863,37.461,13.464,38.842 C1297.627,736.177,1289.758,704.018,1289.758,704.018z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M664.325,1753.882c0,0-0.138,1.435-0.138,3.831c-0.002,7.191,1.233,23.033,11.139,34.724 c13.209,15.588,13.288,34.98-0.668,38.293c-13.955,3.313-47.232-1.06-47.232-1.06s-7.524-14.83-2.385-54.442 c5.137-39.612,8.118-83.056,8.118-83.056l37.918-6.716L664.325,1753.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422F7F"
    },
    d: "M671.756,1770.723c0,0,14.066,21.652,17.358,30.687c3.292,9.034,2.583,31.502,0,33.816 c-22.745,20.37-65.867,2.036-65.867,2.036s-2.965-14.937-4.462-33.27c-1.495-18.333-0.653-35.416,4.462-35.416 c5.115,0,6.013,9.615,17.684,6.899C652.602,1772.759,659.784,1768.006,671.756,1770.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M619.667,1813.123c8.767,3.885,20.67,8.427,31.738,10.22c11.814,1.914,27.72-4.052,39.722-10.047 c0.621,9.605-0.268,20.366-2.013,21.93c-22.745,20.37-65.867,2.036-65.867,2.036S621.216,1827.037,619.667,1813.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7446"
    },
    d: "M773.763,1727.768c-4.922,17.553-0.057,36.88,12.56,48.477 c4.355,4.003,9.413,7.755,15.135,10.593c22.087,10.953,50.696,8.491,54.685,30.989c3.987,22.5-140.06-6.313-140.06-6.313 s9.994-54.724,10.641-63.889c0.646-9.166-0.88-42.826-0.88-42.826l55.629-4.531L773.763,1727.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422F7F"
    },
    d: "M721.932,1772.787c0,0-1.761,8.689-5.795,23.423c-4.034,14.732-1.518,28.607-1.518,28.607 s134.921,7.251,140.383,2.403c5.461-4.847,2.656-22.494,1.275-24.056c-1.38-1.563-18.503-6.81-27.285-12.956 c-8.782-6.145-38.773-29.399-48.905-28.459c-10.133,0.939-14.811,9.429-34.053,10.4 C726.794,1773.119,726.712,1768.546,721.932,1772.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M855.003,1827.22c-5.462,4.847-140.383-2.403-140.383-2.403s-1.651-9.104-0.133-20.394 c70.429,14.801,141.792-1.259,141.792-1.259C857.659,1804.726,860.463,1822.372,855.003,1827.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CB9BD"
    },
    d: "M714.486,1804.423c48.099,10.896,101.417,8.59,141.792-1.259 c-73.439,12.58-132.657,2.832-128.56,3.303C727.539,1806.439,713.598,1804.285,714.486,1804.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422F7F"
    },
    d: "M608.596,1189.771l12.677,554.13l60.646-8.701c0,0,19.215-444.673,30.462-457.852 c11.248-13.18,15.747,0.829,15.747,0.829s48.367,185.001,39.368,221.904c-8.998,36.902-49.152,234.594-49.152,234.594 l58.15,2.636c0,0,66.363-151.565,66.363-257s-41.001-280.722-41.001-280.722L608.596,1189.771z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 716.01,
    y: 1720.676,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1502.0513 3457.6592)",
    style: {
      fill: "#021753"
    },
    width: 70.031,
    height: 16.307
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.904,
    y: 1723.306,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1302.5111 3467.2075)",
    style: {
      fill: "#021753"
    },
    width: 70.703,
    height: 20.595
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021753"
    },
    d: "M634.307,1731.4c0.129,0,0.261-0.017,0.393-0.052c0.967-0.252,1.578-1.378,1.36-2.511 c-11.198-58.682-11.923-439.983-11.928-443.827c-0.001-1.161-0.804-2.1-1.795-2.1h-0.003c-0.99,0.002-1.794,0.944-1.792,2.109 c0.024,15.715,0.73,385.606,12.015,444.736C632.743,1730.735,633.485,1731.4,634.307,1731.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021753"
    },
    d: "M728.205,1731.4c0.731,0,1.418-0.528,1.684-1.379c2.724-8.699,66.632-213.362,63.014-241.623 c-3.566-27.855-44.395-203.319-46.131-210.775c-0.259-1.122-1.25-1.773-2.206-1.475c-0.955,0.307-1.521,1.462-1.259,2.584 c0.424,1.822,42.509,182.68,46.043,210.29c3.484,27.206-62.169,237.43-62.832,239.547c-0.342,1.091,0.134,2.302,1.066,2.7 C727.791,1731.359,728,1731.4,728.205,1731.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBCE9A"
    },
    points: "791.103,801.733 875.753,913.404 776.015,949.784  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE0B2"
    },
    d: "M570.767,765.666c12.862-12.862,42.804-22.308,62.322-27.371 c11.213-2.908,22.876-3.576,34.355-2.02l43.928,5.957c0,0,57.058,36.68,78.454,58.076 c21.398,21.396,40.755,155.379,40.755,155.379l-9.697,51.054l11.159,224.774c-4.911,0-152.239,18.007-234.088-6.548 c0,0,0-119.884-2.258-192.69C586.087,976.982,553.744,782.689,570.767,765.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC98D"
    },
    d: "M571.666,764.798c6.743-6.293,17.129-11.357,25.624-14.872c0.006,0.008,0.009,0.013,0.009,0.013 s16.218-8.892,30.94,51.795c14.723,60.686-3.973,134.519,2.551,141.044c6.524,6.525,149.843-0.869,149.843-0.869 s-83.74,48.129-124.608,83.214c-16.39,14.07-59.857,21.462-59.937,20.999c-0.121-4.765-0.251-9.393-0.389-13.844 C591.059,1005.579,551.944,783.194,571.666,764.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CC7F"
    },
    d: "M933.244,892.668l-71.966,135.98c-1.691,3.195-5.06,5.105-8.633,4.894l-85.497-5.044 c-6.128-0.361-10.19-6.59-8.113-12.44l44.094-124.133c1.244-3.504,4.432-5.92,8.103-6.14l113.37-6.803 C931.775,878.552,936.638,886.253,933.244,892.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB9044"
    },
    d: "M752.268,1015.378l44.652-122.976c1.26-3.472,4.489-5.865,8.206-6.083l4.427-0.26 c-2.575,0.922-4.665,2.953-5.621,5.611l-44.652,124.133c-1.92,5.337,1.337,10.989,6.636,12.212l-5.434-0.313 C754.276,1027.344,750.164,1021.174,752.268,1015.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99662"
    },
    d: "M591.146,931.065l6.793,24.429c0,0,144.681-37.335,161.662-45.486 c13.741-6.596,68.348-21.198,88.685-19.782c3.309,0.231,3.74,4.902,0.514,5.677c-12.799,3.08-38.255,9.524-38.255,12.067 c0,3.396,25.627,8.396,23.775,12.566c-3.736,8.406-16.303,13.246-18.681,21.057c-2.376,7.811-28.386,1.697-37.287,1.697 c-8.902,0-173.961,100.192-223.886,76.418c-49.925-23.774-19.699-129.229-19.699-129.229L591.146,931.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99662"
    },
    d: "M862.449,983.367c3.311-3.311,3.142-11.462,6.962-15.283c3.822-3.821,7.982,3.906,9.001-4.755 c1.019-8.661-5.094-22.076,0.849-21.397c5.944,0.679,14.096,25.133,14.096,25.133c4.28,9.978-14.944,47.208-25.116,44.671 c-10.17-2.538-14.111-14.614-14.111-20.218C854.128,985.914,859.137,986.679,862.449,983.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M711.406,742.252c0.004,0.003,0.008,0.005,0.008,0.005c0.047,0.03,0.117,0.075,0.215,0.138 c0.029,0.019,0.061,0.039,0.095,0.062c0.051,0.033,0.107,0.07,0.169,0.109c0.038,0.025,0.077,0.05,0.118,0.076 c0.102,0.066,0.216,0.14,0.342,0.222c0.044,0.029,0.091,0.059,0.138,0.09c0.128,0.082,0.264,0.171,0.411,0.266 c0.023,0.015,0.046,0.03,0.069,0.044c0.038,0.024,0.076,0.049,0.113,0.074c0.031,0.02,0.062,0.04,0.094,0.06 c0.072,0.047,0.148,0.096,0.224,0.146c0.038,0.025,0.076,0.049,0.114,0.074c0.279,0.182,0.582,0.38,0.911,0.594 c0.059,0.039,0.119,0.078,0.18,0.118c5.42,3.543,17.016,11.211,29.879,20.252v0.001c0,0,5.35,21.457,2.802,35.212 c-2.548,13.756-7.896,18.085-15.538,15.029c-7.642-3.056-21.992-23.423-25.26-22.282c-3.269,1.141-25.429,28.905-36.127,24.575 c-7.194-2.911-28.768-50.143-39.574-78.221c0.781-0.208,1.548-0.409,2.3-0.604c11.213-2.909,22.876-3.577,34.355-2.02 l43.929,5.956l0.016,0.011L711.406,742.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99662"
    },
    d: "M734.423,707.482c-3.43,18.035-5.052,37.478-1.958,48.783c0,0-7.124,30.853-24.891,32.354 c-17.768,1.501-51.428-53.118-51.428-53.118l36.962-58.136L734.423,707.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#F26E5A"
    },
    d: "M730.932,735.792c-21.319-3.736-41.285-20.043-46.825-44.271l9-14.156l41.315,30.117 C732.614,716.994,731.308,726.897,730.932,735.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99662"
    },
    d: "M772.272,598.332c0,0,17.409,109.216-13.735,121.817c-31.145,12.602-73.243-7.614-76.374-44.672 C679.031,638.421,686.962,562.852,772.272,598.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#271798"
    },
    d: "M740.727,575.946c0,0,59.357-17.542,62.867-0.2c3.511,17.341-16.038,30.241-29.651,31.392 c-13.612,1.15-48.401-0.639-58.974,11.885c-10.572,12.524-29.503,70.411-29.503,70.411l-10.689,16.761 c0,0-4.354-30.493-19.733-49.132c-15.379-18.64-6.738-50.73,8.023-72.683C677.827,562.427,727.275,577.083,740.727,575.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99662"
    },
    d: "M702.88,649.229c0,0-5.647-15.3-14.018-13.126c-18.995,4.934-5.056,38.739,1.183,39.664 C702.725,677.647,707.854,667.639,702.88,649.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE0B2"
    },
    d: "M624.395,812.549c0.629,36.234-18.985,143.139-18.985,143.139s-76.077-1.529-82.19-7.642 c-6.113-6.113,13.48-167.435,47.08-190.042C610.429,731.002,623.787,777.588,624.395,812.549z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A491"
    },
    d: "M1887.933,422.534h291.576c27.797,0,50.332-22.534,50.332-50.331V271.539 c0-27.797-22.535-50.331-50.332-50.331h-291.576c-27.797,0-50.331,22.534-50.331,50.331v100.663 C1837.602,400,1860.136,422.534,1887.933,422.534z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A491"
    },
    points: "2106.324,358.45 2113.72,501.094 2013.064,355.116  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounge1);
export default __webpack_public_path__ + "static/media/lounge_1.614e0ed2064e3288bf89bc8b32522147.svg";
export { ForwardRef as ReactComponent };